export default __webpack_public_path__ + "static/media/MetaMask_Fox.45038d58.svg";